export default __webpack_public_path__ + "static/media/solidworks-print.b86ffe7d.png";